/**
 * XHM 硬件伙伴（Overseas patch 256）
 */
export const XHM_HARDWARE_PARTNER_MENU_IDS = {
  group: 990464,
  desk: 990465,
  view: 990466,
  gate: 990467
}

export default XHM_HARDWARE_PARTNER_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/xhmHardwarePartner.js